import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-feature-group-template-modal',
    templateUrl: './feature-group-template-modal.component.html',
    styleUrls: ['./feature-group-template-modal.component.css'],
    imports: [ReactiveFormsModule]
})
export class FeatureGroupTemplateModalComponent implements OnInit {

  proposalForm!: FormGroup;

  @Output() save: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    public modal: NgbActiveModal,) { }

  ngOnInit(): void {
    this.proposalForm = this.fb.group({
      groupTemplateName: ['', Validators.required],
    });
  }

  saveProposalTemplate(){
    if(this.proposalForm.valid){
      this.save.emit(this.proposalForm.value);
      this.closeModal();
    }

  }

  closeModal(){
    this.modal.close();
  }

}
